import React from 'react';
import { IProduct, IVariant } from 'base/interfaces/product';
import { IShowTag } from '@base/snippets/ListProduct/ListProductImage';
import SuperFlashSaleOffTag from '@base/snippets/Tags/SuperFlashSaleOffTag';
import { observer, useStore } from 'base/store';
import { ProductTag } from '@base/snippets/ProductTag'
import { getTagConfig } from 'mod/product/utils'
import { IActivityCode } from 'base/interfacesV2/feature'
import { getProductDiscount, getTagType } from 'base/utils/product'
import { TAG_SUPERFLASHSALE } from 'mod/product/constant'
import { TDiscountStyle } from 'mod/product/interface'

type IProps = {
    showTag?: IShowTag; //是否展示标签，默认不展示
    offTagShow?: TDiscountStyle;
    product: IProduct;
    productTag?: React.ReactNode | false;
}

const ListProductTags: React.FC<IProps> = (props) => {
    const { showTag, product, offTagShow } = props
    const { userStore } = useStore();
    const isInfoLoaded = userStore.isInfoLoaded();

    if (!showTag) {
        return <></>
    }

    // info 未加载完不展示
    if (!isInfoLoaded) {
        return null
    }

    // 字段兼容
    const tag = 'tag' in product ? product.tag : getTagType('productTagsVoList' in product ? (product as IVariant).productTagsVoList : product.productTags)
    const _tag = tag?.toLowerCase()

    const isSuperFlashSale = _tag === TAG_SUPERFLASHSALE
    let tagConfig
    if (isSuperFlashSale) {
        tagConfig = getTagConfig(_tag as IActivityCode, 'listBanner')

    } else {
        tagConfig = getTagConfig(_tag as IActivityCode, 'picTag')

    }

    return (
        <>
            {isSuperFlashSale ? (
                <SuperFlashSaleOffTag
                    tagConfig={tagConfig}
                    className={'absolute'}
                    discountStyle={offTagShow}
                    discount={{
                        text: getProductDiscount(product),
                        type: 'percent'
                    }}
                />
            ): (
                <ProductTag
                    tagConfig={tagConfig}
                    className={'absolute'}
                    discountStyle={offTagShow}
                    discount={{
                        text: getProductDiscount(product),
                        type: 'percent'
                    }}
                />
            )}
        </>
    );
};

export default observer(ListProductTags)